import React from 'react';

import { events } from 'client/screens/WordpressScreen/events';
import { Button } from 'shared/Button/NewButton';
import { useT } from 'client/i18n/hooks/useT';
import { StyledNavLink } from '../../LinkStyles';
import { StyledWrapper } from './styles';
import { clickSignupButton, clickedNavLinkGoogleAnalytics } from '../../events';

export const SignUpLoginNavItems = ({
  pathname = '',
}: {
  pathname: string;
}) => {
  const t = useT();
  const pathnameLowerCase = pathname.toLowerCase();
  const isWpLandingPage = pathnameLowerCase === '/wordpressdotcom';

  return (
    <StyledWrapper>
      <StyledNavLink
        isActive={pathnameLowerCase === '/login'}
        to="/login"
        href=""
        className=""
        isDownloadLink={false}
        onClick={() => {
          clickedNavLinkGoogleAnalytics('Log In');
        }}
      >
        {t(
          'PublicWebsiteNavFooter.SignIn',
          'Sign in',
          'Link to "Sign in" web page'
        )}
      </StyledNavLink>
      <Button
        kind="link"
        color="yellow"
        href={isWpLandingPage ? '/signup?ref=wp' : '/signup'}
        onClick={() => {
          clickSignupButton();
          clickedNavLinkGoogleAnalytics('Sign Up');
          if (isWpLandingPage) {
            events.clickWordPressSignUpCTA('nav');
          }
        }}
      >
        {t(
          'PublicWebsiteNavFooter.SignUp',
          'Get started',
          'Button to "Sign up" web page'
        )}
      </Button>
    </StyledWrapper>
  );
};
